<script>
    import template from "template";

    import hover from "commerce/lib/hover";

    import { game } from "native";

    import css from "../currency.css";

    export let amount;
    export let prevAmount;
    export let options;

    function coinHover(str, e) {
        if (str && e.type === "mouseover") {
            return game.call("ShowTextTooltip", str);
        }

        game.call("HideTextTooltip");
        game.call("HideItemTooltip");
    }

    function handleMouseover(e) {
        if (!hide || digits <= 3) {
            return;
        }

        hover(coinHover.bind(
            null,
            template.sub(window.strings.coins.tooltip),
            {
                gold : goldStr,
                silver,
                copper
            },
            e
        ));
    }

    function handleMouseout(e) {
        if (!hide || digits <= 3) {
            return;
        }

        hover(coinHover.bind(null, null, e));
    }

    function goldScroller(node, { duration = 500 }) {
        if (duration === 0) {
            return;
        }

        const valid = (
            node.childNodes.length === 1 &&
            node.childNodes[0].nodeType === Node.TEXT_NODE
        );

        if (!valid) {
            throw new Error(`This transition only works on elements with a single text node child`);
        }

        return {
            duration,
            tick(t) {
                const curAmount = prevGold + Math.floor((gold - prevGold) * t);

                // assigning to node.textContent will convert the value to string
                // node.textContent = node.textContent.toLocalString() won't work
                node.textContent = digits > 3 ?
                    curAmount.toLocaleString(window.native.stats.language) :
                    curAmount;
            }
        };
    }

    $: gold = Math.floor(amount / 10000) || 0;
    $: silver = Math.floor((amount % 10000) / 100);
    $: copper = amount % 100;
    $: digits = gold.toString().length;
    $: goldStr = digits > 3 ? gold.toLocaleString(window.native.stats.language) : gold;
    $: hide = Boolean(options.hide);
    $: prevGold = Math.floor(prevAmount / 10000) || 0;


    // Don't want this to be rendered, so remove it
    $: if (hide) {
        delete options.hide;
    }

    $: silverCss = options.align ? css.alignedSilver : css.silver;
    $: copperCss = options.align ? css.alignedCopper : css.copper;
</script>

<div
    data-digits={digits > 3 ? "4+" : digits}
    class="{amount ? css.coins : css.empty}"
    on:mouseover={handleMouseover}
    on:mouseout={handleMouseout}
>
    {#key amount}
        <div
            class="{css.gold}"
            data-hide={hide && !gold}
            in:goldScroller={{ duration : prevAmount ? options.duration : 0 }}
        >
            {goldStr}
        </div>
    {/key}

    {#if !options.hideSilver}
        <div class="{silverCss}">{silver}</div>
    {/if}

    {#if !options.hideCopper}
        <div class="{copperCss}">{copper}</div>
    {/if}
</div>

